import React from 'react'

const PrivacyPolicyPage = () => {
  return 'Privacy Policy By clicking Submit, you agree to send your info to Blueroof360 / Real Estate Website Provider who agrees to use it according to their privacy policy. Facebook will also use it subject to our Data Policy, including to auto-fill forms for ads.View Facebook Data Policy. Privacy Policy'
}
export default PrivacyPolicyPage
